module.exports = __webpack_public_path__ + "0cb1a1aaebbf3966b62971efc1adbfc4.svg";